<template>
    <div class="total-panel mt-2 secondary lighten-4" v-if="statistic" style="position: relative">
        <div style="height: 6px; margin-bottom: 4px;">
            <v-progress-linear
                v-if="loading"
                indeterminate
                color  = "primary"
                height = "6"
                class  = "w-100"

            />
        </div>
        <div class="total-title primary white--text" v-html="$t('todo.unit.title')" >
        </div>
        <div>
            <v-switch
                class   = "ml-2 mr-2 mt-2"
                v-model = "todoState.allCustomer"
                label   = "Alle Kunden"
                :ripple = "false"
                @change = "onAll"
                hide-details
                dense
            />
        </div>
        <div>
            <c-customer-select
                label="Kunde"
                :clearable    = "true"
                :my-customers = "!todoState.allCustomer"
                :lim-customer = "todoState.allCustomer"
                :hide-details = "true"
                v-model       = "todoState.selectedCustomer"
                class         = "ml-2 mr-2 mt-0"
                @change       = "onCustomer"
            />
        </div>
        <div class="total-circle secondary lighten-2 white--text mt-12 ml-5 mr-5">
            <div>{{ statistic.total }}</div>
            <div class="total-circle-sub mt-n3">{{ $t('todo.unit.lim.terminated') }}</div>
            <div class="total-circle-sub mt-n1">{{ statistic.terminated }}</div>
        </div>
        <div class="total-subtitle secondary white--text mt-16">
            <div>{{ $t('todo.unit.digitilized') }}</div>
            <div class="mt-n4">
                <span>{{ statistic.digitized }}</span><span style="font-size: smaller"> ({{ percentage(statistic.digitizedPercentage) }})</span>
            </div>
        </div>
        <a @click = "onMails" class="white--text" v-if="bounced.total > 0">
            <div class="total-mail warning white--text mt-16 " style="position: absolute;width: 100%;bottom: 0;}">
                <div>{{ $t('todo.unit.bounced') }}</div>
                <div class="mt-n4">
                    <span>{{ bounced.total }}</span><span style="font-size: smaller"> ({{ bounced.userTotal }})</span>
                </div>
            </div>
        </a>
    </div>
</template>

<script>

import CCustomerSelect from "@/modules/msd/company/customer/components/controlls/CCustomerSelect.vue";
import Inc from "@/modules/inc/service/Inc";

export default {
    name: "PIncUnitsTotal",
    components: {
        CCustomerSelect
    },

    props: {
        loading () {

        }
    },

    data: () => ({
        statistic: null,
        bounced  : {
            total: null,
            userTotal: null
        },
    }),

    mounted() {
        this.initialize();
    },

    computed: {
        preferences () {
            return this.$store.getters.preferences;
        },

        myCustomers () {
            return this.preferences.customer;
        },

        todoState () {
            return this.$store.getters.todo;
        }
    },

    methods: {
        initialize () {
            this.load(() => {
                this.$emit("changed", this.todoState);
            });
        },

        load (success) {
            Inc.todo.units(this.todoState.selectedCustomer, this.todoState.allCustomer).then (data => {
                this.statistic = data;
                this.bounced.total = 0;
                this.bounced.userTotal = 0;

                success ();

                Inc.todo.bounce.totals().then(totals => {
                    totals.forEach (total => {
                        this.bounced.total = this.bounced.total + total.totals;
                        if (total.customerId !== 0) {
                            if (this.myCustomers.find(c => c.id === total.customerId)) {
                                this.bounced.userTotal = this.bounced.userTotal + total.totals;
                            }
                        }
                    })
                })
            })
        },

        onCustomer () {
            this.load(() => {
                this.$emit("changed", this.todoState);
            });
        },

        onMails () {
            this.$emit("bounce");
        },

        onAll () {
            this.load(() => {
                this.$emit("changed", this.todoState);
            });
        },

        percentage (value) {
            return value.toString().replace("/\\./", ",") + "%"
        }
    }
}
</script>

<style scoped>

.total-panel {
    height: calc(100% - 16px);
    border-radius: 6px;
    padding-top: 104px;
    min-width: 200px;
}

.total-title {
    font-weight: 700;
    font-size: 14pt;
    text-align: center;
    line-height: 25px;
    padding: 5px 10%;
    height: 60px;
}

.total-subtitle, .total-mail {
    font-weight: 400;
    font-size: 14pt;
    text-align: center;
    line-height: 38px;
    padding: 0px 10%;
    height: 60px;
}

.total-mail {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}

.total-circle {
    font-weight: 700;
    border-radius: 50%;
    aspect-ratio : 1 / 1;
    text-align: center;
    padding-top: calc(50% - 55px);
    font-size: 30pt;
}

.total-circle-sub {
    font-size: 14px;
    font-weight: 400;
}

</style>